import { observer } from 'mobx-react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
    const location = useLocation();

    if (__LOCAL_DEV__) {
        return <div className="text-center">当前访问路由：{location.pathname}不在开户项目下，请检查URL</div>;
    }

    // 需要用replace，避免返回栈出错
    window.location.replace(`${location.pathname}${location.search}`);

    return null;
};

const Page404: React.FC = () => {
    const location = useLocation();

    return (
        <Routes>
            {/* 本地测试个人中心跳转 /profile */}
            <Route path=":page/*" element={<NotFoundPage />} />
            {/* 老版地址迁移 */}
            <Route
                path="step/*"
                element={
                    <Navigate
                        to={{
                            ...location,
                            pathname: '/open'
                        }}
                        state={location.state}
                        replace
                    />
                }
            />
            <Route
                path="ib/*"
                element={
                    <Navigate
                        to={{
                            ...location,
                            pathname: '/link'
                        }}
                        state={location.state}
                        replace
                    />
                }
            />
            <Route
                path="new/*"
                element={
                    <Navigate
                        to={{
                            ...location,
                            pathname: '/upgrade'
                        }}
                        state={location.state}
                        replace
                    />
                }
            />
            <Route
                path="fix/*"
                element={
                    <Navigate
                        to={{
                            ...location,
                            pathname: '/modify'
                        }}
                        state={location.state}
                        replace
                    />
                }
            />
            {/* 这里非法地址需要跳转，把请求参数保留一下，避免邀请码等信息丢失 */}
            <Route
                path="*"
                element={
                    <Navigate
                        to={{
                            ...location,
                            pathname: '/open'
                        }}
                        state={location.state}
                        replace
                    />
                }
            />
        </Routes>
    );
};

export default observer(Page404);
